import { requireAuth } from '@/router/helpers';

/**
 * FE routes
 */
const FeRoutes = [
  {
    path: '/interestgroups',
    name: 'GroupsList',
    component: () => import('@/views/admin/Groups'),
    beforeEnter: requireAuth,
    meta: { isAdmin: false },
  },
];

const AdminRoutes = [
  {
    path: '/admin/interestgroups',
    name: 'Groups',
    component: () => import('@/views/admin/Groups'),
    beforeEnter: requireAuth,
    meta: { isAdmin: true },
  },

  // Group -> Create
  {
    path: '/admin/interestgroups/create',
    name: 'GroupCreate',
    components: {
      default: () => import('@/views/admin/Groups'),
      panel: () => import('@/views/admin/groups/GroupCreate'),
    },
    beforeEnter: requireAuth,
    meta: {
      openPanel: true,
      isAdmin: true,
    },
  },

  // Group -> Edit
  {
    path: '/admin/interestgroups/:groupId/edit',
    name: 'GroupEdit',
    components: {
      default: () => import('@/views/admin/Groups'),
      panel: () => import('@/views/admin/groups/GroupEdit'),
    },
    beforeEnter: requireAuth,
    meta: {
      openPanel: true,
      isAdmin: true,
    },
  },
];

export default [...FeRoutes, ...AdminRoutes];
